export const DOOR_DESIGNER_STAGES = [
  {
    id: 'frame',
    title: 'Frame',
    stepperLabel: 'Frame & size',
    stepperHint: 'Cill options.',
    description: 'Choose your frame profile, size, and cill.',
  },
  {
    id: 'style',
    title: 'Door Style',
    stepperLabel: 'Door style',
    stepperHint: 'Choose your style.',
    description: 'Choose the door slab style and handing.',
  },
  {
    id: 'colour',
    title: 'Colour',
    stepperLabel: 'Colours',
    stepperHint: 'Door & frame.',
    description: 'Pick finishes for the frame, door, and cill.',
  },
  {
    id: 'glass',
    title: 'Glass',
    stepperLabel: 'Glass',
    stepperHint: 'Glazing options.',
    description: 'Choose a reusable glass design for the door apertures.',
  },
  {
    id: 'furniture',
    title: 'Furniture',
    stepperLabel: 'Furniture',
    stepperHint: 'Handles & extras.',
    description: 'Choose a furniture colour, then a range, then pick handles and extras declared by the selected door style.',
  },
  {
    id: 'review',
    title: 'Review',
    stepperLabel: 'Review',
    stepperHint: 'Your summary.',
    description: 'Check your door before we add quote handoff.',
  },
] as const;

export type DoorDesignerStageId = (typeof DOOR_DESIGNER_STAGES)[number]['id'];

export function getDoorDesignerStage(index: number) {
  return DOOR_DESIGNER_STAGES[Math.max(0, Math.min(index, DOOR_DESIGNER_STAGES.length - 1))];
}

export function isLastDoorDesignerStage(index: number) {
  return index >= DOOR_DESIGNER_STAGES.length - 1;
}
